import React from 'react';
import styled from 'styled-components';
import { Modal, Button, TextButton, Text } from '@amzn/storm-ui-v3';
import { useTranslation } from 'react-i18next';
import { DeleteModalProps, FooterProps } from './types';

const CancelButton = styled(TextButton)`
  margin-right: ${({ theme }) => theme.spacing.base};
`;
CancelButton.displayName = 'CancelButton';

const Footer = (props: FooterProps) => {
  const { t: translate } = useTranslation();

  return (
    <>
      <CancelButton onClick={props.onCloseModal} taktId='cancel-delete-report'>
        {translate('sspa_rcm_ad_reports_delete_subscription_cancel_button_label', 'Cancel')}
      </CancelButton>
      <Button onClick={props.onDeleteReport} primary taktId='delete-report'>
        {translate('sspa_rcm_ad_reports_delete_subscription_delete_button_label', 'Delete report')}
      </Button>
    </>
  );
};

const DeleteModal = (props: DeleteModalProps) => {
  const { t: translate } = useTranslation();

  return (
    <Modal
      isOpen={props.isModalOpen}
      header={translate('sspa_rcm_ad_reports_delete_subscription_popup_title', 'Delete report?')}
      footer={<Footer onCloseModal={props.onCloseModal} onDeleteReport={props.onDeleteReport} />}
      onClose={props.onCloseModal}
    >
      <Text>{translate('sspa_rcm_ad_reports_delete_subscription_popup_message', 'Are you sure you want to delete the report?')}</Text>
    </Modal>
  );
};

export { DeleteModal };
